import { Arrow, Root, Sub, Trigger } from "@radix-ui/react-dropdown-menu";

import { CheckboxItem } from "./CheckboxItem";
import { Content } from "./Content";
import { Group } from "./Group";
import { Item } from "./Item";
import { Label } from "./Label";
import { RadioGroup } from "./RadioGroup";
import { RadioItem } from "./RadioItem";
import { Separator } from "./Separator";
import { SubContent } from "./SubContent";
import { SubTrigger } from "./SubTrigger";

export const DropdownMenu = {
  Root,
  Trigger,
  Arrow,
  Group,
  Sub,
  RadioGroup,
  SubTrigger,
  SubContent,
  Content,
  Item,
  Label,
  Separator,
  CheckboxItem,
  RadioItem,
};

export {
  Arrow as DropdownMenuArrow,
  type DropdownMenuArrowProps,
  type DropdownMenuProps as DropdownMenuRootProps,
  Root as DropdownMenuRoot,
  Sub as DropdownMenuSub,
  type DropdownMenuSubProps,
  type DropdownMenuTriggerProps,
  Trigger as DropdownMenuTrigger,
} from "@radix-ui/react-dropdown-menu";
export { CheckboxItem as DropdownMenuCheckboxItem, type DropdownMenuCheckboxItemProps } from "./CheckboxItem";
export { Content as DropdownMenuContent, type DropdownMenuContentProps } from "./Content";
export { type DropdownMenuGroupProps, Group as DropdownMenuGroup } from "./Group";
export { Item as DropdownMenuItem, type DropdownMenuItemProps } from "./Item";
export { type MenuItemShortcut as DropdownMenuItemShortcut } from "../menu-item";
export { Label as DropdownMenuLabel, type DropdownMenuLabelProps } from "./Label";
export { RadioGroup as DropdownMenuRadioGroup, type DropdownMenuRadioGroupProps } from "./RadioGroup";
export { RadioItem as DropdownMenuRadioItem, type DropdownMenuRadioItemProps } from "./RadioItem";
export { Separator as DropdownMenuSeparator, type DropdownMenuSeparatorProps } from "./Separator";
export { SubContent as DropdownMenuSubContent, type DropdownMenuSubContentProps } from "./SubContent";
export { SubTrigger as DropdownMenuSubTrigger, type DropdownMenuSubTriggerProps } from "./SubTrigger";
export { dropdownLabelVariants } from "./styles";
